<template>
    <!-- 的告警信息组件(主机详情，监控详情都会引用该组件，谨慎修改，quote为区分参数) -->
    <div class="alarmInfo">
        <rcTable :tableAttr="tableAttr"
                 ref="alarmTable"
                 @onSelectChange="onSelectChange">
            <Button @click="refreshAlarm"
                    slot="tootipL">
                <i class="icon-refresh-o-2"></i>
            </Button>
        </rcTable>
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api'
export default {
    name: 'alarmInfo',
    props: ['quote', 'isNoPer', 'isLocak'],
    components: {
        rcTable
    },
    data () {
        return {
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_MONDETAIL_ALARMS_INFO, true),
                    params: {
                        target: this.$route.params.id
                    }
                },
                isMultiSelect: true,
                pageData: {
                    pageSize: 5,
                    pageSizeOpts: [5, 10, 15, 20]
                },
                columns: [
                    {
                        key: 'alarmLevel',
                        title: this.$t('告警级别'),
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        width: 120,
                        searchType: 'select',
                        render: (h, params) => {
                            return h('span', {
                                attrs: { title: params.row.alarmLevelName },
                                class: this.getClass(params.row.alarmLevel)
                            }, params.row.alarmLevelName)
                        }
                    },
                    {
                        key: 'content',
                        title: this.$t('告警内容'),
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            return h('span', { class: 'rc-ellipsis', attrs: { title: params.row.content } }, params.row.content)
                        }
                    },
                    {
                        key: 'alarmStartTime',
                        title: this.$t('发生时间'),
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            return h('span', { class: 'rc-ellipsis', attrs: { title: params.row.alarmStartTime } }, params.row.alarmStartTime)
                        }
                    },
                    {
                        key: 'source',
                        title: this.$t('告警来源'),
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            return h('span', params.row.source === 'cmp' ? this.$t('云管平台') : this.$t('原平台'))
                        }
                    },
                    {
                        key: 'recoveredTime',
                        title: this.$t('解决时间'),
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            return h('span', { class: 'rc-ellipsis', attrs: { title: params.row.recoveredTime } }, params.row.recoveredTime)
                        }
                    },
                    {
                        key: 'status',
                        title: this.$t('告警状态'),
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        width: 120,
                        render: (h, params) => {
                            return h('statusview', {
                                props: {
                                    state: params.row.status === 'active' ? 'error' : params.row.status,
                                    stateName: params.row.status === 'active' ? this.$t('未解决') : this.$t('已解决')
                                }
                            })
                        }
                    }
                ]
            },
            choosed: []
        }
    },
    methods: {
        // 刷新
        refreshAlarm () {
            this.$refs.alarmTable.refreshTable()
        },
        getClass (lev) {
            switch (lev) {
                case '1':
                    return 'font-instance-stopped'
                case '2':
                    return 'rc-color-orange'
                case '3':
                    return 'rc-color-blue'
                case '4':
                    return 'rc-color-gray'
            }
        },
        // 表格勾选
        onSelectChange (rows) {
            this.choosed = rows
        },
        // 删除
        deleteFun () {
            this.$Modal.confirm({
                title: '删除',
                content: '您确认解决选中的告警信息？',
                onOk: () => {
                    const ids = this.choosed.map(item => item.id)
                    this.axios.post(this.urlFormat(API.POST_MONDETAIL_ALARMS_INFO, true), { sids: ids }).then(res => {
                        this.refreshAlarm()
                    })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
</style>
